import { render, staticRenderFns } from "./BetConfirmedMarketView.vue?vue&type=template&id=f220ba84&scoped=true"
import script from "./BetConfirmedMarketView.vue?vue&type=script&lang=js"
export * from "./BetConfirmedMarketView.vue?vue&type=script&lang=js"
import style0 from "./BetConfirmedMarketView.vue?vue&type=style&index=0&id=f220ba84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f220ba84",
  null
  
)

export default component.exports